import type { SiteConfig } from '@/types'

export const siteConfig: SiteConfig = {
    name: 'Moments',
    description:
        'An interactive photography wall that parts around your cursor — click any frame to bring the moment to centre.',
    url: 'https://modulify.com',
    links: {
        twitter: 'https://x.com/modulify',
        instagram: 'https://www.instagram.com/modulify_ai',
        linkedin: 'https://www.linkedin.com/company/modulify-ai'
    }
}
